<template>
  <footer class="footer">
    <Top-Footer></Top-Footer>
    <Bottom-Footer></Bottom-Footer>
  </footer>
</template>

<script>
import TopFooter from "./FooterComponents/TopFooter";
import BottomFooter from "./FooterComponents/BottomFooter";

export default {
  name: "MainFooter",
  props: ["preLoading"],
  data() {
    return {};
  },
  components: {
    TopFooter,
    BottomFooter
  },
  mounted() {
    setTimeout(this.disabledPreLoading, 3000);
  },
  methods: {
    disabledPreLoading() {
      this.$emit("update:preLoading", false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/MainFooter.vue